export const REACT_QUERY_KEY = 'editRouteHistoryMetrics';
